import { render, staticRenderFns } from "./ChangeProfilePriceAdd.vue?vue&type=template&id=21556cd3"
import script from "./ChangeProfilePriceAdd.vue?vue&type=script&lang=js"
export * from "./ChangeProfilePriceAdd.vue?vue&type=script&lang=js"
import style0 from "./ChangeProfilePriceAdd.vue?vue&type=style&index=0&id=21556cd3&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports